import SearchIcon from "components/icons/SearchIcon";
import React, {useMemo, useState} from "react";
import {
    MdChevronRight,
    MdChevronLeft,
    MdCircle,
    MdCircleNotifications,
    MdConfirmationNumber,
    MdEdit, MdOutlineSave, MdOutlineCancel, MdFileDownload, MdPerson, MdDownload, MdPeople, MdOutlineCreate
} from "react-icons/md";
import {
    useGlobalFilter,
    usePagination,
    useSortBy,
    useTable,
} from "react-table";
import {DiAndroid, DiApple} from "react-icons/di";
import {utils, writeFile} from "xlsx";
import {NumberInput} from "@chakra-ui/react";
import avatar from "assets/img/profile/Subtractprofile white.png";
import axios from "axios";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";

function DpIdOverView(props) {
    const {columnsData, tableData} = props;

    const columns = useMemo(() => columnsData, [columnsData]);
    const data = useMemo(() => tableData, [tableData]);

    const tableInstance = useTable(
        {
            columns,
            data,
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,

        prepareRow,
        nextPage,
        previousPage,
        setPageSize,

        setGlobalFilter,
        state,
    } = tableInstance;

    const {pageSize} = state;
    const currentPage = state.pageIndex; // Page index starts from 0
    const totalPages = Math.ceil(data.length / pageSize);

    let [userEditable, setUserEditable] = useState(false);
    let [acl, setAcl] = useState("")

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    const secretKey = "cromptonssecretkey";
    let [selectedValue, setSelectedValue] = useState("100")
    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);

    const [editingRowId, setEditingRowId] = useState(null);
    const [editForm, setEditForm] = useState({
        type: "string",
        name: "",
        dpid: 0
    });



    const startEditDp = (row) => {
        //console.log(row);
        const known = ["String", "Enum", "Integer", "Float", "Char", "Boolean", "other"];
        const rowType = (row.type ?? "");
        const rowValue = (row.name ?? "");

        //console.log(rowType);
        //console.log(rowValue);

        setEditingRowId(row.dpid);
        setEditForm({
            type: known.includes(rowType) ? rowType : "other",
            name: rowValue,
        });
    };

    const cancelEditDp = () => {
        setEditingRowId(null);
        setEditForm({ type: "string", name: "" });
    };

    const saveEditDp = async (row) => {
        const finalType =
            editForm.type === "other" ? editForm.otherType.trim() : editForm.type;

        if (!finalType) return alert("Type is required");

        // Build payload: always update type, update value only if user entered something
        //console.log(editForm);
        const payload = { dpid: row.dpid, type: finalType, name: editForm.value };

        /*if (editForm.name.trim() !== "") {
            payload.name = editForm.name; // user chose to change it
        }*/

        //console.log(payload);
        form = payload
        await createNewDpid(payload);
        cancelEditDp();
    };

    function getCurrentDate() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Jan is 0!
        const year = today.getFullYear();

        return `${day}-${month}-${year}`
    }

    function exportUserData() {
        let filteredData

        filteredData = data.map((item) => ({
            DpId: item.dpid,
            DPName: item.name,
            Type: item.type
        }));

        let wb = utils.book_new(),
            ws = utils.json_to_sheet(filteredData);
        utils.book_append_sheet(wb, ws, "crompton_dpid_details")
        writeFile(wb, "crompton_dpid_details" + getCurrentDate() + ".xlsx")
    }

    function createNewDpid() {
        //console.log(form)
        return axios({
            method: 'post',
            url: CROMPTON_ANALYTICS_URL + 'v1/device/dpId/create',
            data: form,
            headers: {
                Authorization: decryptedValue,
            }
        }).then(response => {
            //console.log(response)
            //window.location.reload()

        })
            .catch(
                error => {
                    //console.log(error)
                }
            )

    }

    const [open, setOpen] = useState(false);

    let [form, setForm] = useState({
        dpid: 0,
        name: "",
        type: "String"
    });

    const close = () => setOpen(false);

    const onChange = (e) => {
        const {name, value} = e.target;
        setForm((p) => ({...p, [name]: value}));
        //console.log("FORM: ", form)
    };

    const onSubmit = (e) => {
        e.preventDefault();
        //console.log(form);

        const finalType = form.type === "other" ? form.otherType.trim() : form.dpType;

        if (!form.dpid.trim() || !form.name.trim() || !form.type.trim()) {
            alert("Please fill all required fields.");
            return;
        }

        // If dpNumber should be numeric only:
        if (!/^\d+$/.test(form.dpid.trim())) {
            alert("DP number must be digits only.");
            return;
        }

        // call your function / API
        createNewDpid({
            dpid: form.dpid.trim(),
            name: form.name.trim(),
            dpType: finalType,
        });

        // reset + close
        setForm({dpid: 0, name: "", dpType: "String"});
        close();
    };

    return (
        <div>
            <div
                className={`h-full w-full transition duration-200 ${
                    open ? "blur-sm pointer-events-none select-none" : ""
                }`}
            >

                {/* Search */}
                <div className="mx-auto mt-5 flex w-full gap-1 overflow-hidden md:!gap-6 xl:w-[96%]">
                    <div
                        className="flex h-[45px] w-full rounded-xl border !border-gray-200 dark:!border-none dark:!bg-navy-700 md:w-[870px] xl:w-full"
                        onChange={(e) => setGlobalFilter(e.target.value)}>
                        <SearchIcon className="dark:text-white"/>
                        <input
                            placeholder="Search..."
                            className="!w-full rounded-xl text-sm font-medium outline-none dark:bg-navy-700 dark:text-white sm:w-[50px] xl:!w-full"
                            type="text"
                        />
                    </div>
                    <button
                        className="flex items-center justify-center rounded-xl border
          !border-gray-200 p-3 text-navy-700 transition duration-200 hover:cursor-pointer
          hover:bg-gray-100 active:bg-gray-50 dark:!border-none dark:bg-navy-700 dark:text-white
          dark:hover:bg-white/20 dark:active:bg-white/10"
                        onClick={() => setOpen(true)}
                        type="button"
                    >
                        <MdOutlineCreate/>
                        <span className="ml-2">New</span>
                    </button>

                    <button className="flex items-center justify-center rounded-xl border
                !border-gray-200 p-3 text-navy-700 transition duration-200 hover:cursor-pointer
                hover:bg-gray-100 active:bg-gray-50 dark:!border-none dark:bg-navy-700 dark:text-white
                dark:hover:bg-white/20 dark:active:bg-white/10" onClick={exportUserData}>
                        <MdDownload/>
                        Export
                    </button>
                </div>

                {/* table */}
                <div className="mt-[14px] h-full w-full overflow-x-scroll 2xl:overflow-x-hidden">
                    <table {...getTableProps()} className="mt-8 h-max w-full" variant="simple" color="gray-500"
                           mb="24px">
                        <thead className="w-full">
                        {headerGroups.map((headerGroup, index) => (
                            <tr
                                className="items-center border-b border-gray-200 dark:!border-white/10"
                                {...headerGroup.getHeaderGroupProps()}
                                key={index}
                            >
                                {/* {...column.getHeaderProps(column.getSortByToggleProps())}*/}
                                {headerGroup.headers.map((column, index) => (
                                    <th

                                        className="border-b border-gray-200 pr-20 pb-[10px] text-start dark:!border-navy-700"
                                        key={index}
                                    >
                                        <div className="text-xs font-bold tracking-wide text-gray-600">
                                            {column.render("Header")}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                        {page.map((row, indexPage) => {
                            prepareRow(row);
                            return (
                                <tr
                                    className="border-b border-gray-200 dark:!border-white/10"
                                    {...row.getRowProps()}
                                    key={indexPage}
                                >
                                    {row.cells.map((cell, index) => {
                                        let data = "";
                                        if (cell.column.Header === "DP ID") {
                                            data = (
                                                <div className="flex items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value}
                                                    </p>
                                                </div>
                                            );
                                        }else if (cell.column.Header === "DP NAME") {
                                            const rowData = cell.row.original;
                                            const isEditing = editingRowId === rowData.dpid;

                                            data = (
                                                <div className="flex flex-col gap-1">
                                                    {/* Always visible original value */}
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value ?? "-"}
                                                    </p>

                                                    {/* When editing, show an input (optional). If left empty, value won't change */}
                                                    {isEditing && (
                                                        <input
                                                            value={editForm.value}
                                                            onChange={(e) => setEditForm((p) => ({ ...p, value: e.target.value }))}
                                                            className="mt-1 w-full rounded-md border px-2 py-1 text-sm dark:bg-navy-700 dark:text-white"
                                                            placeholder="Enter new value (optional)"
                                                        />
                                                    )}
                                                </div>
                                            );
                                        } else if (cell.column.Header === "TYPE") {
                                            const rowData = cell.row.original;
                                            const isEditing = editingRowId === rowData.dpid;

                                            data = (
                                                <div className="flex items-center gap-2">
                                                    {isEditing ? (
                                                        <div className="flex items-center gap-2">
                                                            <select
                                                                value={editForm.type}
                                                                onChange={(e) =>
                                                                    setEditForm((p) => ({
                                                                        ...p,
                                                                        type: e.target.value,
                                                                        otherType: e.target.value === "other" ? p.otherType : "",
                                                                    }))
                                                                }
                                                                className="rounded-md border px-2 py-1 dark:bg-navy-700 dark:text-white"
                                                            >
                                                                <option value="String">String</option>
                                                                <option value="Enum">Enum</option>
                                                                <option value="Integer">Integer</option>
                                                                <option value="Boolean">Boolean</option>
                                                                <option value="Float">Float</option>
                                                                <option value="Char">Char</option>
                                                                <option value="Fault">Fault</option>
                                                                <option value="other">Others</option>
                                                            </select>

                                                            {editForm.type === "other" && (
                                                                <input
                                                                    value={editForm.otherType}
                                                                    onChange={(e) => setEditForm((p) => ({
                                                                        ...p,
                                                                        otherType: e.target.value
                                                                    }))}
                                                                    placeholder="custom type"
                                                                    className="w-32 rounded-md border px-2 py-1 dark:bg-navy-700 dark:text-white"
                                                                />
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <p className="text-sm font-bold text-navy-700 dark:text-white">{cell.value}</p>
                                                    )}
                                                </div>
                                            );
                                        } else if (cell.column.Header === "ACTIONS") {
                                            const rowData = cell.row.original;
                                            const isEditing = editingRowId === rowData.dpid;

                                            data =
                                                accesscontrollevel.toString() === "1" ? (
                                                    !isEditing ? (
                                                        <button
                                                            className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600"
                                                            onClick={() => startEditDp(rowData)}
                                                            type="button"
                                                        >
                                                            <MdEdit/>
                                                        </button>
                                                    ) : (
                                                        <div className="grid grid-cols-2 gap-2 items-center">
                                                            <button
                                                                className="max-h-fit w-full max-w-max cursor-pointer text-xl"
                                                                type="button"
                                                                onClick={() => saveEditDp(rowData)}
                                                            >
                                                                <MdOutlineSave className="text-green-800"/>
                                                            </button>

                                                            <button
                                                                className="max-h-fit w-full max-w-max cursor-pointer text-xl"
                                                                type="button"
                                                                onClick={cancelEditDp}
                                                            >
                                                                <MdOutlineCancel className="text-red-800"/>
                                                            </button>
                                                        </div>
                                                    )
                                                ) : (
                                                    <button
                                                        className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600"
                                                        type="button">
                                                        <MdPeople className="text-green-800"/>
                                                    </button>
                                                );
                                        }
                                        return (
                                            <td
                                                {...cell.getCellProps()}
                                                key={index}
                                                className="pt-[14px] pb-[16px] sm:text-[14px]"
                                            >
                                                {data}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
                {/* pagination */}
                <div className=" mt-2 flex h-20 w-full items-center justify-between px-6">
                    {/* left side */}
                    <div className=" flex items-center gap-3">
                        <p className="> Show rows per page text-sm text-gray-700 font-bold dark:text-white">
                            Show rows per page{" "}
                        </p>
                        <select
                            value={pageSize}
                            onChange={(e) => setPageSize(Number(e.target.value))}
                            className="h-[32px] w-[75px] rounded-[20px] border border-gray-700 px-2 text-gray-700 font-bold dark:!border-white/10 dark:bg-navy-800 dark:text-white"
                            name=""
                            id=""
                        >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div className="flex items-center gap-4">
                        <p className="text-sm font-bold text-gray-700 dark:text-white">
                            Page {currentPage + 1} of {totalPages}
                        </p>
                    </div>
                    {/* right side */}
                    <div className="flex items-center gap-3">
                        {state.pageIndex !== 0 && (
                            <button
                                onClick={previousPage}
                                disabled={state.pageIndex === 0}
                                className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                            >
                                <MdChevronLeft/>
                            </button>
                        )}
                        <p className="text-sm text-gray-700 font-bold dark:text-white ">
                            {currentPage + 1}
                        </p>
                        {state.pageIndex !== totalPages - 1 && (
                            <button
                                onClick={nextPage}
                                disabled={state.pageIndex === totalPages}
                                className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                            >
                                <MdChevronRight/>
                            </button>
                        )}
                    </div>
                </div>
            </div>
            {open && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
                    onMouseDown={close} // click outside closes
                >
                    <div
                        className="w-full max-w-lg rounded-xl bg-white p-5 shadow-lg dark:bg-navy-800"
                        onMouseDown={(e) => e.stopPropagation()} // prevent closing when clicking inside
                    >
                        <h2 className="text-lg font-semibold text-navy-700 dark:text-white">
                            Create New DP
                        </h2>

                        <form className="mt-4 space-y-4" onSubmit={onSubmit}>
                            {/* DP Number */}
                            <div>
                                <label className="block text-sm text-gray-600 dark:text-gray-200">
                                    DP ID *
                                </label>
                                <input
                                    name="dpid"
                                    value={form.dpid}
                                    onChange={onChange}
                                    className="mt-1 w-full rounded-lg border border-gray-200 p-2 dark:border-white/10 dark:bg-navy-700 dark:text-white"
                                    placeholder="e.g. 101"
                                    inputMode="numeric"
                                />
                            </div>

                            {/* DP Name */}
                            <div>
                                <label className="block text-sm text-gray-600 dark:text-gray-200">
                                    DP Name *
                                </label>
                                <input
                                    name="name"
                                    value={form.name}
                                    onChange={onChange}
                                    className="mt-1 w-full rounded-lg border border-gray-200 p-2 dark:border-white/10 dark:bg-navy-700 dark:text-white"
                                    placeholder="e.g. Temperature"
                                />
                            </div>

                            {/* DP Type */}
                            <div>
                                <label className="block text-sm text-gray-600 dark:text-gray-200">
                                    DP Type *
                                </label>
                                <select
                                    name="type"
                                    value={form.type}
                                    onChange={(e) => {
                                        const v = e.target.value;
                                        setForm((p) => ({
                                            ...p,
                                            type: v,
                                        }));
                                    }}
                                    className="mt-1 w-full rounded-lg border border-gray-200 p-2 dark:border-white/10 dark:bg-navy-700 dark:text-white"
                                >
                                    <option value="String">String</option>
                                    <option value="Enum">Enum</option>
                                    <option value="Integer">Integer</option>
                                    <option value="Boolean">Boolean</option>
                                    <option value="Float">Float</option>
                                    <option value="Char">Char</option>
                                    <option value="Fault">Fault</option>
                                    <option value="other">Others</option>
                                </select>

                                {form.dpType === "other" && (
                                    <input
                                        name="otherType"
                                        value={form.type}
                                        onChange={onChange}
                                        className="mt-2 w-full rounded-lg border border-gray-200 p-2 dark:border-white/10 dark:bg-navy-700 dark:text-white"
                                        placeholder="Enter custom type"
                                    />
                                )}
                            </div>

                            <div className="flex justify-end gap-2 pt-2">
                                <button
                                    type="button"
                                    onClick={close}
                                    className="rounded-lg border border-gray-200 px-4 py-2 text-navy-700 hover:bg-gray-100 dark:border-white/10 dark:text-white dark:hover:bg-white/10"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="rounded-lg bg-navy-700 px-4 py-2 text-white hover:opacity-90 dark:bg-blue-500"
                                    /*onClick={createNewDpid}*/
                                >
                                    Create
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>


    )

        ;
}

export default DpIdOverView;

